module.exports = __webpack_public_path__ + "5688493c61c2a5073087d7edc4aa9902.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/icons/canada_icon.png
// module id = 1225
// module chunks = 0